import React, { useState } from 'react'

import { ampli } from '@Analytics/ampli'
import { Success } from '@Components/CMS/LeadMagnet/Success'
import { Title } from '@Components/CMS/Title'
import { CSImage } from '@Components/CS/Image'
import { SubscribeNewsletterForm } from '@Components/SubscribeNewsletterForm'
import { gtm } from '@Globals/Google/DataLayer'
import { useNewsletterSubscription } from '@Globals/Newsletter/useNewsletterSubscription'

import styles from './LeadSubscribeForm.module.scss'

interface LeadSubscribeFormProps {
  buttonText: string
  closeModal: () => void
  desktopImage: string
  identifyingLabel: string
  mobileImage: string
  successMsg: string
  text: string
  title: string
}
export const LeadSubscribeForm = ({
  buttonText,
  closeModal,
  desktopImage,
  identifyingLabel,
  mobileImage,
  successMsg,
  text,
  title,
}: LeadSubscribeFormProps) => {
  const [subscribed, setSubscribed] = useState(false)
  const { subscribe } = useNewsletterSubscription()

  if (subscribed) {
    return <Success onClose={() => closeModal()} successMsg={successMsg} />
  }

  const onSubscribe = async (email: string) => {
    setSubscribed(true)
    await subscribe({ campaignLabel: identifyingLabel, email, source: 'cms_lead_magnet' })

    gtm({
      event: 'leadMagnetCms',
      moduleKey: identifyingLabel,
    })

    ampli.cmsLeadMagnetOptIn({
      campaign_label: identifyingLabel,
    })
  }

  const hasImage = desktopImage || mobileImage

  return (
    <div className={styles.leadSubscribeForm}>
      <Title title={title} type="h1" />
      <p className={styles.infoText} dangerouslySetInnerHTML={{ __html: text }} />

      <SubscribeNewsletterForm
        onSubscribe={onSubscribe}
        submitText={buttonText}
        variant="row"
      />

      {hasImage && (
        <div className={styles.imageWrapper}>
          <CSImage
            alt=""
            url={mobileImage || desktopImage}
            width={500}
          />
        </div>
      )}
    </div>
  )
}
